import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {
  year = new Date().getFullYear();
  constructor(private router: Router,) { }

  ngOnInit() {

    const rol_id = localStorage.getItem('rol_id')

  
      this.router.navigateByUrl('/calculadora');
    
    
  }

}
